import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchCustomerMessages } from 'src/api/customer/notes';
import {
    FETCH_CUSTOMER_MESSAGES,
    requestCustomerMessages,
    requestCustomerMessagesFailure,
    requestCustomerMessagesSuccess,
} from './actions';

/* Customer Messages */
function* fetchCustomerMessagesSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerMessages());

    const { error, response } = yield call(fetchCustomerMessages);

    if (error) yield put(requestCustomerMessagesFailure(error));
    else yield put(requestCustomerMessagesSuccess(response));
}

export function* generateFetchCustomerMessagesWatcher() {
    yield takeLatest(FETCH_CUSTOMER_MESSAGES, fetchCustomerMessagesSaga);
}
